// Layout for the event surfaces (bead hf-e4-events-needs-6r5.1).
//
// CSS-only, like the plan surfaces: no JavaScript width branching, so a jsdom test
// renders what a phone renders and there is no breakpoint state to fall out of sync.
// Every colour, space and radius is a design-system token; nothing here invents a
// value.
export const eventStylesheet = `
.event-form { display: grid; gap: var(--space-16, 1rem); max-width: 42rem; }
.event-form h2 { margin: 0; }

.event-detail__state { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); margin: 0 0 var(--space-12, 0.75rem); }
.event-detail__facts { display: grid; gap: var(--space-4, 0.25rem); margin: 0;
  grid-template-columns: minmax(8rem, auto) 1fr; }
.event-detail__facts dt { font-weight: 600; color: var(--color-ink-muted, #5b6862); }
.event-detail__facts dd { margin: 0; }
.event-detail__note { color: var(--color-ink-muted, #5b6862); margin: var(--space-12, 0.75rem) 0 0; }
.event-detail__actions { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem);
  margin-top: var(--space-16, 1rem); }

.event-history__list, .event-history__changes { list-style: none; margin: 0; padding: 0; }
.event-history__list { display: grid; gap: var(--space-12, 0.75rem); }
.event-history__entry { padding-top: var(--space-12, 0.75rem);
  border-top: 1px solid var(--color-border, #d7ded9); }
.event-history__revision { font-weight: 600; margin: 0; }
.event-history__when { color: var(--color-ink-muted, #5b6862); margin: 0; }

/* Tablet: facts read two-up beside a wider action row. */
@media (min-width: 768px) {
  .event-detail__facts { grid-template-columns: minmax(10rem, auto) 1fr; }
}

/* Desktop: a readable measure rather than full-bleed (plan section 21.6). */
@media (min-width: 1280px) {
  .event-detail__facts, .event-history__list { max-width: 720px; }
}
`;
